import { WorkflowAction } from './WorkflowAction';

// One thing a sweep found in the portal: a pointer to referral activity, NOT a document.
// Each item becomes its own portal_automation retrieval run (OLIO-2756), which is why a
// sweep never touches the attachments packet. Read shape is camelCase — the API stores
// snake_case keys and OliveBranch camelCases them on the response.
export interface DiscoveredItem {
  referenceOrUrl: string;
  patientName?: string | null;
  content?: string | null;
}

// The DiscoverPortalActivity action kind (OLIO-2757). A sweep hands off to a person or the
// browser extension, which reports what it found as `discovered_items`. Everything reads
// from THIS instance's own output, so a re-run card reflects exactly what that run found
// rather than the newest sweep's results.
export class DiscoverPortalActivityAction extends WorkflowAction {
  // A sweep that legitimately found nothing publishes an empty list — that is a real,
  // successful result, so absent and empty must read the same and neither is an error.
  get items(): DiscoveredItem[] {
    const value = this.outputFor('discovered_items');
    return Array.isArray(value) ? (value as DiscoveredItem[]) : [];
  }

  get itemCount(): number {
    return this.items.length;
  }

  get hasItems(): boolean {
    return this.itemCount > 0;
  }
}
